const OPTIONS = [
  { value: "made_to_order", label: "Dibuat saat dipesan" },
  { value: "stocked", label: "Stok siap jual" },
];

const InventoryModeField = ({ value = "made_to_order", onChange, name, disabled = false }) => (
  <fieldset className="mb-0" disabled={disabled}>
    <legend className="form-label fs-5 mb-2">Cara kelola stok</legend>
    <div className="akas-scope-filter d-inline-flex flex-wrap gap-1">
      {OPTIONS.map((option) => (
        <label key={option.value} className={`btn btn-sm ${value === option.value ? "btn-primary" : "btn-white"}`}>
          <input
            type="radio"
            className="form-check-input me-2"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          {option.label}
        </label>
      ))}
    </div>
    <p className="text-secondary small mt-2 mb-0">
      {value === "stocked"
        ? "Produksi menambah stok siap jual dan memakai bahan resep. Penjualan hanya mengurangi stok produk."
        : value === "non_stock"
          ? "Produk ini menggunakan pengaturan lama tanpa stok. Tidak ada stok yang dikurangi."
          : "Bahan resep berkurang saat penjualan diproses. Tidak perlu produksi lebih dulu."}
    </p>
  </fieldset>
);

export default InventoryModeField;
